import { addLocale, locale } from 'primereact/api';
import React, { useState,useEffect } from 'react';
import App from '../App/App';
import { Route, Switch, useHistory, BrowserRouter as Router } from 'react-router-dom'


import {
    PJTemplate,
    setProfile,
    useProfile,
    useProfiles,
    useUserInfo
} from '@jaf/jaf-react-core';
import AppMenu from '../App/AppMenu';
  

function Wrapper(props) {

    const profile = useProfile();
    const changeProfileEnabled = profile != null;

    const isLogged = useUserInfo() != null;
    

    const i18nConf = {
        addLocale: addLocale, //USO INTERNO NON MODIFICARE
        locale: locale, //USO INTERNO NON MODIFICARE
        changeLanguageEnabled: true //default false
    }

    const oAuthConfig = {
        customUrlOpener: undefined //default null
    }

    
    const themeConfig = {
        changeThemeEnabled: true
    }

    const profileConfig = {
        changeProfileEnabled: changeProfileEnabled
    }
const [redirectPath, setRedirectPath] = useState(sessionStorage.getItem("postLoginRedirect"));
    
    const appContainerConf = {
        main: <App redirectPath={redirectPath}/>,
        menu: null,
        toastPosition: 'top-center',
        hideTopbar: false, //default true
        hideDbTestBanner: false, //default false
    }

    const history = useHistory();
    const profiles = useProfiles();
    

    useEffect(() => {
    
        if (redirectPath && isLogged) {
          sessionStorage.removeItem("postLoginRedirect");
    
          if(isLogged && redirectPath.includes("/dottorandi") && profiles != null && profiles.length > 0 && profile == null){
            console.log("wrapper - profiles: " , profiles);
            setProfile(profiles.filter(p => p.profile == 5)[0]);
          }
          
        }
    
      }, [redirectPath,isLogged,history,profiles]);

    return (
        <>
            <PJTemplate
            i18NConfig={i18nConf}
            oAuthConfig={oAuthConfig}
            appConfig={appContainerConf}
            themeConfig={themeConfig}
            profileConfig={profileConfig}
        />
    </>
    )
}

export default Wrapper
